document.addEventListener('DOMContentLoaded', () => {
  const tabButtons = document.querySelectorAll('.tab-link');
  const tabContent = document.querySelectorAll('.tab-content');

  tabButtons.forEach((tabButton) => {
    tabButton.addEventListener('click', (event) => {
      // Set the active tab button
      tabButtons.forEach((item) => {
        item.classList.remove('active');
      });
      event.target.classList.add('active');

      // Set the active tab content
      tabContent.forEach((item) => {
        item.classList.remove('active');
      });
      const activeTabContent = event.currentTarget.dataset.tabContent;
      document.getElementById(activeTabContent).classList.add('active');
    });
  });
});
